<template>
  <div>
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="70px" :hide-required-asterisk="true">
        <div>
          <el-form-item label="考试名称" prop="roomId" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-select v-model="form.roomId" placeholder="选择考试" :disabled="row && !!row.roomId" filterable style="width: 100%;">
              <el-option v-for="(item,index) in batchList" :key="index" :label="item.roomName" :value="item.roomId" :class="item.disabled?'none':''"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('closeChange', form)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'changeRoom',
  components: {},
  props: ['row', 'room', 'batch'],
  data () {
    return {
      form: null,
      batchList: []
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      this.batchList = await this.$HTTP.GradeRoom.getList({ batchId: this.batch, isFill: 1 })
      // console.log(this.batchList);
      if (this.Tool.isNull(this.batchList)) {
        throw new Error('没有考试数据')
      } else {
        this.form = {
          batchId: this.batchList[0].batchId
        }
      }
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      // console.log(this.form.roomId);
      if (isOK) {
        let res = await this.$HTTP.GradeExam.getChangeRoom({ evaluateExamId: this.row, roomId: this.form.roomId })
        // console.log(res);
        this.$message({ type: 'success', message: '修改成功' })
        this.$emit('closeChange', this.form)
      }
    }
  }
}
</script>
